// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"542":"93e02494","688":"43710180","826":"f64a1976","842":"2290c24e","868":"046c6c6f"}[chunkId] + ".chunk.css";
};